<template>
  <div v-loading="loading"
       class="appeal-detail-panel">
    <template v-if="detail && detail.id != null">
      <div class="appeal-section">
        <div class="section-label">申诉原因：</div>
        <div class="section-box">{{ detail.appeal_reason || '-' }}</div>
      </div>
      <div class="appeal-section">
        <div class="section-label">申诉材料：</div>
        <div v-if="detail.appeal_materials && detail.appeal_materials.length"
             id="appealPhotoContainer"
             class="material-list">
          <div v-for="(m, i) in detail.appeal_materials"
               :key="i"
               class="material-item"
               @contextmenu.prevent.stop="onMaterialContextmenu($event, m)">
            <video v-if="m.type === 'video'"
                   :src="m.url"
                   class="photo-view-image video-preview"
                   preload="metadata"
                   @click="openVideoDialog(m.url, i)"></video>
            <img v-else-if="m.type === 'img'"
                 :src="m.url | ossFormatJpg"
                 @click="onViewPhotos(i)"
                 alt=""
                 class="photo-view-image">
            <a v-else
               :href="m.url"
               target="_blank">{{ m.name || m.url }}</a>
          </div>
        </div>
        <div v-else
             class="empty-tip">暂无材料</div>
      </div>
    </template>
    <div v-else
         class="empty-tip">{{ loading ? '加载中...' : '暂无申诉信息' }}</div>

    <video-player-dialog
      :visible.sync="videoDialogVisible"
      :videos="videoDialogVideos"
      :index="videoDialogIndex" />

    <ul v-show="menu.visible"
        class="material-context-menu"
        :style="`top:${menu.top}px;left:${menu.left}px`"
        @click.stop>
      <li>
        <el-button type="text"
                   size="small"
                   :disabled="!canCopy(menu.target)"
                   @click="copyMaterial(menu.target)">复制</el-button>
      </li>
      <li>
        <el-button type="text"
                   size="small"
                   :disabled="!menu.target"
                   @click="downloadMaterial(menu.target)">下载</el-button>
      </li>
    </ul>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import download from 'downloadjs'
import VideoPlayerDialog from '@views/user-workinfo/components/VideoPlayerDialog.vue'
import ContextMenu from '@views/question-review/components/ContextMenu'
import { orderAppealMixin } from '@views/order/mixins/order-appeal.mixins.js'

export default {
  name: 'AppealDetailPanel',
  mixins: [orderAppealMixin],
  components: { VideoPlayerDialog },
  props: {
    orderId: {
      type: [Number, String],
      required: true,
    },
  },
  data () {
    return {
      viewer: null,
      videoDialogVisible: false,
      videoDialogVideos: [],
      videoDialogIndex: 0,
      menu: {
        visible: false,
        top: 0,
        left: 0,
        target: null,
      },
    }
  },
  computed: {
    // 申诉单由 orderReview/fetchOrderAppeal 统一拉取，这里只读取避免重复请求
    ...Vuex.mapState('orderReview', {
      detail: state => state.orderAppeal || {},
      loading: state => state.orderAppealLoading,
    }),
  },
  mounted () {
    document.addEventListener('click', this.hideMenu)
    window.addEventListener('scroll', this.hideMenu, true)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.hideMenu)
    window.removeEventListener('scroll', this.hideMenu, true)
    if (this.viewer) {
      this.viewer.destroy()
      this.viewer = null
    }
  },
  methods: {
    getAppealStatusTag (value) {
      const map = {1: 'warning', 2: 'success', 3: 'danger', 4: 'info', 5: 'info'}
      return map[value] || 'info'
    },
    getAppealStatusLabel (value) {
      const item = this.appealStatusOptions.find(i => i.value === value)
      return item ? item.label : '未知'
    },
    onViewPhotos (index) {
      if (this.viewer) {
        this.viewer.destroy()
      }
      this.viewer = new Viewer(document.getElementById('appealPhotoContainer'))
      this.viewer.view(index)
    },
    openVideoDialog (url, index) {
      const videoList = (this.detail.appeal_materials || [])
        .filter(m => m.type === 'video')
        .map(m => m.url)
      this.videoDialogVideos = videoList
      this.videoDialogIndex = Math.max(videoList.indexOf(url), 0)
      this.videoDialogVisible = true
    },
    canCopy (m) {
      return !!m && (m.type === 'img' || m.type === 'video')
    },
    onMaterialContextmenu (event, m) {
      this.menu.target = m
      this.menu.left = event.clientX
      this.menu.top = event.clientY
      this.menu.visible = true
    },
    hideMenu () {
      this.menu.visible = false
    },
    downloadMaterial (m) {
      if (!m || !m.url) return
      this.hideMenu()
      download(filter.ossHost(m.url))
    },
    copyMaterial (m) {
      if (!this.canCopy(m)) return
      this.hideMenu()
      const isVideo = m.type === 'video'
      const type = isVideo ? 'video' : 'photo'
      const file = isVideo
        ? { type: 'video', src: m.url, cover: m.cover || '' }
        : { type: 'photo', src: m.url }
      ContextMenu().setCopyType(type)
      // setStageFiles 内部会用它自己遗留的 this.type 写一次 localStorage，因此下面必须再覆盖写一次
      ContextMenu().setStageFiles([file])
      localStorage.setItem('copyForReloadReviewData', JSON.stringify([file]))
      localStorage.setItem('copyForReloadReviewDataType', type)
      this.$message.success('已复制，可到答案证据处右键粘贴')
    },
  },
}
</script>

<style lang="scss" scoped>
.appeal-detail-panel {
  font-size: 13px;
}
.appeal-section {
  margin-bottom: 14px;
  &:last-child {
    margin-bottom: 0;
  }
}
.section-label {
  color: #909399;
  font-size: 13px;
  margin-bottom: 6px;
}
.section-box {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 10px 12px;
  color: #303133;
  line-height: 1.6;
  word-break: break-all;
}
.material-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.material-item {
  display: inline-block;
  vertical-align: top;
  text-align: center;
}
.material-context-menu {
  position: fixed;
  z-index: 3000;
  min-width: 80px;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  border-radius: 3px;
  margin: 0;
  padding: 0;
  list-style-type: none;

  li {
    border-radius: 3px;

    &:hover {
      background-color: rgba(235, 238, 245, 0.95);
    }
  }

  button {
    padding: 5px 10px;
    width: 100%;
    text-align: left;
  }
}
.photo-view-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  display: block;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
}
.video-preview {
  position: relative;
  cursor: pointer !important;
  background-color: #000;
}
.empty-tip {
  color: #909399;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/pages/OrderReviewSidebarPanel/AppealDetailPanel.vue